import { Formik } from 'formik'
import * as Yup from 'yup'

import { ModalHeader, FloraTypography, ModalBody, Flex, FloraButton } from '@grupoboticario/flora-react'

import FormField from '@/components/FormField/FormField'
import ActionModal from '@/components/Modal/ActionModal'

import * as S from './ModalFinishCampaign.styles'

export const ModalFinishCampaign = ({ openFinishModal, setOpenFinishModal, handleSubmit, isLoading }) => {
  return (
    <ActionModal css={S.modalWrapperCss} onOpenChange={setOpenFinishModal} open={Boolean(openFinishModal)} size="small">
      <ModalHeader>
        <FloraTypography as="h5" fontSize="title">
          Encerrar acelerador
        </FloraTypography>
      </ModalHeader>
      <ModalBody>
        <Flex direction="column" gap="$4">
          <FloraTypography fontSize="bodyLargeStandard" css={S.bodyTextCss}>
            O acelerador será finalizado e não poderá ser reiniciado. Se necessário, configure um novo acelerador.
          </FloraTypography>
          <Formik
            enableReinitialize
            initialValues={{
              description: ''
            }}
            onSubmit={handleSubmit}
            validateOnChange
            validationSchema={Yup.object().shape({
              description: Yup.string().required('Digite uma justificativa para o encerramento do acelerador')
            })}
          >
            {({ errors, isValid, values }) => (
              <Flex direction="column" gap="$6">
                <FormField
                  invalid={typeof errors?.description === 'string'}
                  invalidText={errors.description}
                  labelText="Justificativa"
                  name="description"
                  required
                />
                <Flex align="center" gap="$6" justify="center">
                  <FloraButton
                    disabled={isLoading}
                    isFull
                    onClick={() => setOpenFinishModal(false)}
                    hierarchy="secondary"
                  >
                    Voltar
                  </FloraButton>
                  <FloraButton
                    disabled={values.description === '' || !isValid || isLoading}
                    isFull
                    isLoading={isLoading}
                    onClick={(event) => handleSubmit(event, values)}
                  >
                    Encerrar
                  </FloraButton>
                </Flex>
              </Flex>
            )}
          </Formik>
        </Flex>
      </ModalBody>
    </ActionModal>
  )
}
